export default __webpack_public_path__ + "static/media/nzd.27335081.png";